import musicMasterLogo from './musicmaster.png';
import music1Logo from './music1.png';
import gSelectorLogo from './gselector.jpg';
import aiirLogo from './aiir.png';
import nbsLogo from './nbs.png';
import admasterLogo from './admaster.svg';
import trafficOneLogo from './trafficone.png';
import aquiraLogo from './aquira.png';
import myriadschedulerLogo from './myriadschedule.png';

export function SupportedSoftwareSection() {
    return <>
        <h2>Supported Music Scheduling Software</h2>
        <ul className="supported-logos">
            <li>
                <a href="https://www.musicmaster.com/" target="_blank">
                    <img src={musicMasterLogo} className="supported-logo-image" alt="MusicMaster Scheduling" />
                    <span className="supported-logo-title">MusicMaster Scheduling</span>
                </a>

                <figcaption>
                    Download the export designer file below and import it into MusicMaster Export File Designer as a Delimited ASCII Text Design.
                    <hr />
                    When exporting to Automation, select "PlayIt Playout Log" as the Export Design.
                    <hr />
                    Contact MusicMaster Support if you require assistance.
                    <hr />
                    <a href="/PlayIt Live Export Design.xml" download="PlayIt Live Export Design.xml" className="download-button">Download Export Designer File</a>
                </figcaption>
            </li>
            <li>
                <a href="https://gomusic1.com/" target="_blank">
                    <img src={music1Logo} className="supported-logo-image" alt="Music 1" />
                    <span className="supported-logo-title">Music 1</span>
                </a>

                <figcaption>
                    Under the Automation tab, select the PlayIt format.
                </figcaption>
            </li>
            <li>
                <a href="https://www.rcsworks.com/gselector/" target="_blank">
                    <img src={gSelectorLogo} className="supported-logo-image" alt="GSelector" />
                    <span className="supported-logo-title">GSelector</span>
                </a>

                <figcaption>
                    The automation export formats in GSelector are user configurable. 
                    Please contact RCS Support for more information.
                </figcaption>
            </li>
            <li>
                <a href="https://aiir.com/scheduler/" target="_blank">
                    <img src={aiirLogo} className="supported-logo-image" alt="Aiir Scheduler" />
                    <span className="supported-logo-title">Aiir Scheduler</span>
                </a>
                <figcaption>
                    Select PlayIt Live in Station Outputs.
                </figcaption>
            </li>
            <li>
                <a href="https://www.broadcastradio.com/myriad-6-schedule-pro" target="_blank">
                    <img src={myriadschedulerLogo} className="supported-logo-image" alt="Myriad Schedule Pro" />
                    <span className="supported-logo-title">Myriad Schedule Pro</span>
                </a>
                <figcaption>
                    Go to the "Station" menu then select "Station Settings". On the "Log Import/Export" tab click the button at the bottom to add an Export and select "PlayIt Live log file".
                </figcaption>
            </li>
        </ul>
        <h2>Supported Traffic Scheduling Software</h2>
        <ul className="supported-logos">
            <li>
                <a href="https://www.admaster.info/" target="_blank">
                    <img src={admasterLogo} className="supported-logo-image" alt="AdMaster" />
                    <span className="supported-logo-title">AdMaster</span>
                </a>
                <figcaption>
                    Under Playout integration / output format, select PlayIt (pipl).
                </figcaption>
            </li>
            <li>
                <a href="https://www.nat-soft.com/" target="_blank">
                    <img src={nbsLogo} className="supported-logo-image" alt="Natural Log" />
                    <span className="supported-logo-title">Natural Log</span>
                </a>

                <figcaption>
                    Under Automation &gt; Automation Log Type, select PlayIt.
                </figcaption>
            </li>
            <li>
                <a href="https://www.traffic1.pro" target="_blank">
                    <img src={trafficOneLogo} className="supported-logo-image" alt="TrafficONE" />
                    <span className="supported-logo-title">TrafficONE</span>
                </a>

                <figcaption>
                    Contact TrafficONE Support for more information.
                </figcaption>
            </li>
            <li>
                <a href="https://www.rcsworks.com/aquira" target="_blank">
                    <img src={aquiraLogo} className="supported-logo-image" alt="Aquira" />
                    <span className="supported-logo-title">Aquira</span>
                </a>

                <figcaption>
                    The automation export formats in Aquira are user configurable. 
                    Contact RCS Support for more information.
                </figcaption>
            </li>            
        </ul>        
        <hr />
        <p>
            The PlayIt Playout Log Format 2.0 is a new format and we are working with music scheduling software vendors to support it.
        </p>
        <p>
            If you are a music scheduling software user and would like to see support for the format, please refer your vendor to this website.
        </p>
        <p>
            If you are a music scheduling software vendor and would like to support the format, please <a href="https://www.playitsoftware.com/Contact" target="_blank">get in touch</a>.
        </p>
    </>;
}
